import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Row, Col, Select } from 'antd';
import { SearchOutlined  } from '@ant-design/icons';
import FormModal from './FormModal'
import FormImport from './FormImport'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
import customerMasterDataAPI from "../../../apis/customerMasterDataAPI";
import UPM from '../../../constants/urlPermissionMappings';
@inject('customerMasterDataStore','homeStore','uiState')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
    importModalVisible: false,
    customer: '',
    custList: [],
  }
  formRef = React.createRef();
  componentDidMount() {
    const { customerMasterDataStore, dataType, record } = this.props;
    this.getCust()
    customerMasterDataStore.onChangeCustomer('')
    customerMasterDataStore.onSearchMasterDataClear({
      names: undefined,
      customer: '',
    },1,PAGE_SIZE_DEFAULT)
    if(dataType==='parameter'){
      console.log('record', record)
      customerMasterDataStore.onSearchMasterDataAction({
        id: record.id,
        name: record.name,
        type: 'parameter'
      },1,PAGE_SIZE_DEFAULT)
    }
    // if(dataType==='parameter'){
    //   customerMasterDataStore.onSearchMasterDataAction({
    //     names: [name],
    //     type: 'parameter'
    //   },1,PAGE_SIZE_DEFAULT)
    // }else {
    //   homeStore.onGetCustomerAction({"dictionaryType":"API_ROUTER_CUSTOMER"},'2')
    //   customerMasterDataStore.onChangeMasterDataList([])
    // }
  }
  getCust =() => {

    customerMasterDataAPI.getCustAction().then(res => {
      this.setState({
        custList: res.data.data
      })
    })
  }
  handleSearch=()=>{
    const { customerMasterDataStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        names: fieldsValue.names!==undefined?fieldsValue.names.length>0?fieldsValue.names:undefined:undefined,
        customer: fieldsValue.customer,
        // type: 'Lookup'
      }
      customerMasterDataStore.onSearchMasterDataAction(params,1,PAGE_SIZE_DEFAULT)
    }).catch(err => {
    })
  }
  handleCreate=()=>{
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  onChange=(value,evt)=>{
    const { customerMasterDataStore } = this.props
    // var customer= []
    // customer.push(value)
    customerMasterDataStore.onGetNameAction(value)
    customerMasterDataStore.onChangeCustomer(value)
    customerMasterDataStore.onChangeCustomerStr(evt.children)
    this.setState({
      customer: value
    })
    if(value===undefined){
      this.formRef.current.setFieldsValue({
        names: []
      })
      this.setState({
        customer: ''
      })
    }
    if(this.state.customer!==value) {
      this.formRef.current.setFieldsValue({
        names: []
      })
    }
  }
  onChangeNames=(value)=>{
    const { customerMasterDataStore } = this.props
    customerMasterDataStore.onChangeNames(value)
  }
  handleImport=()=>{
    this.setState({
      importModalVisible: true
    })
  }
  handleCancelImport=()=>{
    this.setState({
      importModalVisible: false
    })
  }
  handleExport = () => {
    const { customerMasterDataStore, uiState } = this.props
    // const { customerValue } = customerMasterDataStore
    // this.formRef.current.validateFields().then(fieldsValue => {
    //   uiState.onChangeFetchingExport('/config/masterData/excel/export', {customer: customerValue,type: "Lookup"}, `${customerValue}_MasterData.xlsx`)
    // }).catch(err => {
    // })
    const { customerStr} = customerMasterDataStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        names: fieldsValue.names!==undefined?fieldsValue.names.length>0?fieldsValue.names:undefined:undefined,
        customer: fieldsValue.customer,
        // type: 'Lookup'
      }
      uiState.onChangeFetchingExport('/config/masterData/excel/export', params, `${customerStr}_MasterData.xlsx`)
    }).catch(err => {
    })
  }
  render() {
    const { customerMasterDataStore, dataType,record, location } = this.props
    const { nameList } = customerMasterDataStore
    return (
      <>
        <Form ref={this.formRef} className='searchForm' layout="vertical">
        {dataType==='parameter' ? null: <div className='searchFormTitle'>
            <SearchOutlined /> {UPM.find(item => item.url === location?.pathname)?.title}
          </div>}
          <Row gutter={[10,0]}>
            {dataType==='parameter' ?
              <Col span={24} style={{textAlign: 'right'}}>
                <Button onClick={this.handleCreate} type='primary'>Add</Button>
              </Col>:<>
                <Col span={4}>
                  <Form.Item name='customer' label='Customer' rules={[{ required:true, message: 'Please select Customer.'}]}>
                    <Select placeholder="Please select ..." onChange={this.onChange} showSearch >
                      {this.state.custList.length>0 ? this.state.custList.map(item => <Select.Option key={item.id} value={item.id}>{item.customer}</Select.Option>):null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='names' label='Name'>
                    <Select placeholder="Please select ..." onChange={this.onChangeNames} allowClear showArrow mode="multiple" maxTagCount='responsive' maxTagTextLength={16} disabled={this.state.customer === ''}>
                      {nameList.length>0 ? nameList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>):null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={10} offset={6} style={{textAlign: 'right', marginTop: 30}}>
                  <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
                  <Button style={{marginRight: 10}} onClick={this.handleCreate} type='primary'>Add</Button>
                  <Button style={{marginRight: 10}} onClick={this.handleImport} type='primary'>Import</Button>
                  <Button style={{marginRight: 10}} onClick={this.handleExport} type='primary'>Export</Button>
                </Col>
            </>}
          </Row>
        </Form>
        {this.state.addModalVisible?<FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          dataType={dataType}
          record={record}
        />:null}
        {this.state.importModalVisible?<FormImport
          modalVisible={this.state.importModalVisible}
          handleCancel={this.handleCancelImport}
        />:null}
      </>
    );
  }
}

export default SearchForm;
